import { Component } from '../jsti/core';
import Template from '../classes/Template';
import AsyncRequest from '../classes/AsyncRequest';
import { price } from '../classes/Helpers';
import Notifications from '../constants/Notifications';

export default class AlternativeProduct extends Component {
  template: HTMLElement;
  container: HTMLElement;
  /**
   * Initialize the component
   *
   * @param pEl
   */
  async bind(pEl: HTMLElement): void {
    super.bind(pEl);
    const template = this.el.querySelector('template[ref="alternative-product"]');
    const container = document.getElementByRef('alternative-product-container');
    if (!template) {
      throw new Error('A template is required');
    }
    this.template = Template.getContent(template);

    if (!container) {
      throw new Error('A container is required');
    }
    this.container = container;
    let productIds: number[] = [];

    try {
      productIds = JSON.parse(this.el.dataset.alternativeIds);
    } catch {
    }

    if (productIds.length) {
      const alternativeProduct = await this.loadProduct(productIds);
      if (!alternativeProduct) return;
      this.buildAlternativeProduct(alternativeProduct);
    }
    this.addListener(Notifications.CHANGE_PRODUCT, this.handleChangeProduct);
  }

  /**
   *
   */
  async loadProduct(productIds) {
    const { data } = await AsyncRequest.post('', {
      product_ids: productIds,
      product_type: 'simple-product'
    }, '/product-feed');
    if (data.products[0]) {
      return data.products[0];
    }
  }

  /**
   *
   */
  buildAlternativeProduct(product) {
    const title = this.template.getElementByRef('title');
    const priceElement = this.template.getElementByRef('price');
    const image = this.template.getElementByRef('image');
    const rating = this.template.getElementByRef('rating');
    const addToCartButton = this.template.getElementByRef('add-to-cart-button');
    const productLink = this.template.getElementByRef('product-link');

    image.src = product.image.src;
    addToCartButton.dataset.sku = product.sku;

    const stars: NodeList<HTMLElement> = rating.getElementsByRef('star');
    if (stars) {
      for (let i = 0; i < stars.length; i++) {
        const star: HTMLElement = stars[i];
        if (product.ratings.average > i) {
          const icon = star.getElementByRef('icon');
          icon.classList.add('text-secondary');
        }
      }
    }

    const count = this.template.getElementByRef('count');
    const countContainer = this.template.getElementByRef('count-container');

    count.innerText = product.ratings.count;

    rating.innerHTML = '';

    [...stars].forEach((star: HTMLElement) => {
      rating.appendChild(star);
    });

    rating.appendChild(countContainer);

    title.innerHTML = product.title;
    priceElement.innerHTML = price(product.price);
    productLink.href = product.slug;

    this.container.classList.remove('hidden');
    this.container.appendChild(this.template);
    this.notify(Notifications.UPDATE_FEATURED_REVIEW, { review: null });
  }

  /**
   *
   */
  async handleChangeProduct(pData: Object): void {
    this.container.innerHTML = '';

    if (pData.product.alternative_product_ids.length) {
      const alternativeProduct = await this.loadProduct(pData.product.alternative_product_ids);
      if (!alternativeProduct) return;
      this.buildAlternativeProduct(alternativeProduct);
    } else {
      this.notify(Notifications.SHOW_FEATURED_REVIEW);
      this.container.classList.add('hidden');
    }
  }
}
